<template>
  <v-card
    :class="$vuetify.breakpoint.mobile ? 'flex-column pa-3' : 'mr-2 my-4 pa-1'"
    class="px-3 cursor-pointer"
    @click.passive="onClickInformationAbonnement()"
  >
    <div class="d-flex justify-center max-width pt-2">
      <img
        alt="target"
        class="align-self-center"
        src="@/assets/info-abonnement/target.svg"
      >
      <v-icon
        v-if="!isAbonneCulturial"
        class="align-self-center"
        size="18"
        color="#EC6608"
      >
        mdi-lock
      </v-icon>
      <span class="intro align-self-center pb-1 ml-3">Créez vos scénarios prévisionnels à venir</span>
      <v-icon
        class="align-self-center ml-1 pb-1"
        size="22"
        color="primary"
      >
        mdi-chevron-right
      </v-icon>
    </div>
    <InformationAbonnementModal
      v-if="isOpenModalInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalInformationAbonnement"
      code-feature="PREVISIONNEL"
      texte="Déterminez votre prix d'équilibre par culture pour l'année à venir en prenant en compte vos nouveaux investissements."
      titre="Créer votre scénario prévisionnel"
      :is-conseiller-pv-affiche="!isAbonneCulturial"
      @close="isOpenModalInformationAbonnement = false"
    />
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'

export default {
  name: 'PrevisionRebond',
  components: {InformationAbonnementModal},
  data () {
    return {
      isOpenModalInformationAbonnement: false
    }
  },
  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements'
    }),

    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    }
  },
    methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement'
    }),
    onClickInformationAbonnement () {
      this.isOpenModalInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('PREVISIONNEL')
    }
  }
}
</script>
<style lang="scss" scoped>
.max-width {
  overflow: hidden;
  text-overflow: ellipsis;
}
.cursor-pointer {
  cursor:pointer;
}
</style>
